import { connect } from 'react-redux';
import Header from './component';

const mapStateToProps = (state) => ({
    operatorId: state.session.operatorId
});

export default connect(mapStateToProps)(Header);


// WEBPACK FOOTER //
// ./src/components/Pages/Dashboard/Header/container.js